import React from "react";
import { Link } from "@quintype/components";

import "./app-logo.m.css";

import { SvgIconHandler } from "../../atoms/svg-icon-hadler/index";

export const AppLogo = () => {
  return (
    <div styleName="wrappper" className="app-logo-wrapper">
      <Link href="/" aria-label="app-logo">
        <SvgIconHandler className="mobile-logo" type="bdnews24-logo" width="164" height="19" viewBox="0 0 164 19" />
        <SvgIconHandler className="desktop-logo" type="bdnews24-logo" width="300" height="40" viewBox="0 0 300 40" />
      </Link>
    </div>
  );
};
